<template>
  <div :class="(boxStyle != false) ? 'box box-primary' : ''">
    <div class="box-body">
      <!-- Table -->
      <div style="overflow: auto;display:inline-block;">
        <table
          class="table table-bordered"
          style="word-wrap: break-word;hyphens: auto;table-layout: fixed;
        width: 100%;border:0px solid red;"
        >
          <tbody>
            <!-- Header and Border Defined -->
            <ul
              v-if="hdBackground != undefined"
              style="display:contents;margin: 0;padding: 0; border:1px solid red;"
            >
              <th
                :style="hdBackground"
                v-for="key in columns"
                v-show="(columns[0]['text']) ? key.isHidden : true"
                @click="sortBy(columns[0]['text'] ? key.text : key)"
                :class="{ active: sortKey == (columns[0]['text'] ? key.text : key ) }"
                :key="key.id"
              >
                {{ (columns[0]['text']) ? $t(key.text) : $t(key) | capitalize }}
                <span
                  v-if="arrow != undefined"
                  :class="[sortOrders[(columns[0]['text']) ? key.text : key] > 0 ? 'asc' :'dsc', arrow]"
                ></span>
                <span
                  v-else
                  class="arrow"
                  :class="[sortOrders[(columns[0]['text']) ? key.text : key] > 0 ? 'asc' :'dsc']"
                ></span>
              </th>
            </ul>
            <!-- Aadd Data -->
            <ul
              v-if="tblBorder == undefined"
              style="display: contents;margin:0;padding: 0; border:1px solid red;"
            >
              <tr
                :style="tableBorder"
                v-for="(entry, indexRow) in filteredData"
                :key="namePrivilege + '-' + indexRow"
                :id="namePrivilege + '-' + indexRow"
              >
                <td
                  v-for="(header_key, indexColumn) in columns"
                  :style="tableBorder"
                  v-show="(columns[0]['text']) ? header_key.isHidden : true"
                  :key="(columns[0]['text']) ? header_key.text.id : header_key.id"
                  @click="onClickItemRow(entry.id)"
                >
                  <!-- Add Column CheckBox -->
                  <input
                    v-if="indexColumn > 0"
                    type="checkbox"
                    v-bind:value="namePrivilege + '-' + indexRow + '-' + indexColumn"
                    v-bind:id="namePrivilege + '-' + indexRow + '-' + indexColumn"
                    v-bind:name="namePrivilege + '-' + indexRow + '-' + indexColumn"
                    :checked="selected"
                    @change="checkItems($event)"
                  />
                  <span>{{(columns[0]['text']) ? entry[header_key.text] : entry[header_key]}}</span>
                </td>
              </tr>
            </ul>
          </tbody>
        </table>
      </div>
      <b-button
        @click="callback($event)"
        style="float:right !important;" variant="success">Button</b-button>
    </div>
    <!-- Pagination -->
  </div>
</template>

<script>

export default {
  name: "lte-table",
  props: [
    "data",
    "columns",
    "actions",
    "views",
    "hdBackground",
    "tblBorder",
    "isVisibility",
    "useFilter",
    "useCheckBox",
    "customColumns",
    "arrow",
    "boxStyle",
    "namePrivilege"
  ],
  data() {
    return {
      searchQuery: "",
      sortKey: "",
      sortOrders: {},
      recordData: {},
      actionsType: 0,
      tblDefaultBorder: "border: 1px solid #f4f4f4",
      hdDefaultBackground: "background-color: #008f68",
      isModalVisible: false,
      emitfilteredData: [],
      keepCheckItems: [],
      selected: null,
      selectAll: false,
    };
  },
  watch: {
    customColumns: function() {},
    columns: function() {
      // console.log(this.columns);
    },
    namePrivilege: function() {
      // console.log(this.namePrivilege)
    }
  },
  computed: {
    filteredData: function() {
      //does not this feature
      // if (!this.useFilter) {
      //   return this.data;
      // }

      let sortKey = this.sortKey;
      let filterKey = this.searchQuery && this.searchQuery.toLowerCase();
      let order = this.sortOrders[sortKey] || 1;
      let data = this.data;

      if (filterKey) {
        data = data.filter(function(row) {
          return Object.keys(row).some(function(key) {
            return (
              String(row[key])
                .toLowerCase()
                .indexOf(filterKey) > -1
            );
          });
        });
      }
      if (sortKey) {
        data = data.slice().sort(function(a, b) {
          a = a[sortKey];
          b = b[sortKey];
          return (a === b ? 0 : a > b ? 1 : -1) * order;
        });
      }

      this.$emit("filters", data);
      this.$emit("searchQuery", this.searchQuery);
      return data;
    },
    tableBorder: function() {
      return this.tblDefaultBorder;
    },
    headerDefaultBackground: function() {
      return this.hdDefaultBackground;
    }
  },
  filters: {
    capitalize: function(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  },
  methods: {
    sortBy: function(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
    },
    onClickItemRow: function(entryId) {
      this.$emit("onClickItemRow", entryId);
    },
    checkItems: function(data) {
      this.$emit("selectedItems", data);
    },
    callback: function() {
      alert("ĐANG PHÁT TRIỂN")
    }
  },
  components: {
  },
  created() {
    let sortOrders = {};
    if (this.columns[0]["text"]) {
      this.columns.forEach(function(key) {
        sortOrders[key.text] = 1;
      });
    } else {
      this.columns.forEach(function(key) {
        sortOrders[key] = 1;
      });
    }

    this.sortOrders = sortOrders;
    this.$emit("searchQuery", this.searchQuery);
    // console.log(this.namePrivilege)
  }
};
</script>

<style lang="scss" scoped>
.row_mouse_pointer {
  cursor: pointer;
}

.isVisibility {
  display: none;
}
table > th {
  cursor: pointer;
}
div .right-search {
  width: 300px;
  margin-bottom: 5px;
  float: right;
}

div .left-search {
  width: 300px;
  margin-bottom: 5px;
  float: left;
}

th,
td {
  min-width: 50px;
  padding: 5px 7px;
  // padding: 10px 20px;
}

th.active {
  color: aquamarine;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #fae042;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #fae042;
}

th.active .other_color_arrow {
  opacity: 1;
}

.other_color_arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.other_color_arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid black;
}

.other_color_arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid black;
}

#grid-template {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  width: 600px;
}
.custom-box {
  border-radius: 3px;
  background: #ffffff;
  border: 1px solid #e6e9ed;
  border-bottom: 0px;
  margin-bottom: 2px;
  width: 100%;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 0px rgba(0, 0, 0, 0.1);
}
.active_line {
  // wheat
  background-color: lightblue;
}
.more-btn,
.more-menu-btn {
  border-radius: 5px;
  background-color: #c9302c;
  border: 0 none;
  // border-color: #ac2925;
  line-height: normal;
  overflow: visible;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  width: 100%;
  text-align: left;
  margin-bottom: 0px;
  outline: none;
  cursor: pointer;
}

.more-dot {
  background-color: white;
  margin: 0 auto;
  display: inline-block;
  width: 5px;
  height: 5px;
  margin-right: 1px;
  margin-bottom: 2px;
  border-radius: 50%;
  transition: background-color 0.3s;
}

.label-darkcyan {
  background-color: darkcyan !important;
}
.label-crimson {
  background-color: crimson !important;
}
.label-darkblue {
  background-color: darkblue !important;
}
</style>



// WEBPACK FOOTER //
// src/components/LTETableCheckBox.vue